import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ExperienceProvider } from '@mc/experience'
import { HelpCenterEventProvider, Tracker } from '../../events'
import { DecagonAi, DecagonUserInfo } from '../DecagonAi'
import { GladChat } from '../GladChat'
import { GladlySearchProvider } from './GladlySearch'

export interface LayoutExtraParams {
  pageProps: {
    userAttributes: DecagonUserInfo
  }
  withSearch?: boolean
  withWidget?: boolean
}

export interface GladlySearchLayoutProps {
  children: React.ReactNode | React.ReactNode[]
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
})

const getLayout = (page: React.ReactElement, config: LayoutExtraParams) => (
  <QueryClientProvider client={queryClient}>
    <ExperienceProvider>
      <HelpCenterEventProvider>
        <Tracker />
        {config.withSearch ? (
          <GladlySearchProvider>{page}</GladlySearchProvider>
        ) : (
          page
        )}
        {config.withWidget ? (
          <>
            <DecagonAi userAttributes={config.pageProps.userAttributes} />
            <GladChat />
          </>
        ) : null}
      </HelpCenterEventProvider>
    </ExperienceProvider>
  </QueryClientProvider>
)

export const helpCenterLayout =
  ({
    withSearch = false,
    withWidget = true,
  }: {
    withSearch?: boolean
    withWidget?: boolean
  }) =>
  (page: React.ReactElement, extraParams: LayoutExtraParams) =>
    getLayout(page, { ...extraParams, withSearch, withWidget })
